// extracted by mini-css-extract-plugin
export default {"othersRegnJumbotron":"AdminHome_othersRegnJumbotron__oRWT+","regnJumbotron":"AdminHome_regnJumbotron__oLKs3"};